<template>
  <div>
    <div class="grid_flex mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_title_header ma-2">
          <img :src="$props.img_header">
        </div>
        <h2 class="title_header">{{ $props.header }}</h2>
      </div>

      <v-btn color="#28ab28" class="titlefont_header d-none d-sm-flex white--text grad-success-bg" height="50" width="20%" @click="$router.push('/'+$props.link_back)">
        ย้อนกลับ
      </v-btn>
      <v-btn color="#28ab28" class="titlefont_header d-flex d-sm-none white--text grad-success-bg" height="50" @click="$router.push('/'+$props.link_back)">
        ย้อนกลับ
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerifyCheckHeader",
  data() {
    return {
      image: null
    }
  },
  props: ['header', 'img_header', 'link_back'],
}
</script>

<style scoped>
.title_header{
  margin-left: 10px;
}
.img_title_header{
  width: 50px;
}
.img_title_header > img{
  max-width: 100%;
}
.titlefont_header{
  font-size: 20px !important;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
  .title_header{
    margin-left: 10px;
    font-size: 25px;
  }
}
</style>
